(() => {
  if (window.dropiBuyNowInitialized) return;
  window.dropiBuyNowInitialized = true;

  let requestInProgress = false;
  const errorMessage = 'No pudimos agregar el producto. Intenta nuevamente.';

  function getSystemElement() {
    return document.querySelector('[data-dropi-buy-system]');
  }

  function getVariantId(systemElement) {
    const purchaseModule = document.querySelector('#dropi-purchase');
    const productForm =
      purchaseModule?.querySelector('form[data-type="add-to-cart-form"][action*="/cart/add"]') ||
      purchaseModule?.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm?.querySelector('[name="id"]:not([disabled])');
    return variantInput?.value || systemElement.dataset.fallbackVariantId;
  }

  function getErrorElement(button) {
    let error = button.nextElementSibling;
    if (!error?.classList.contains('dropi-buy-now-error')) error = null;

    if (!error) {
      error = document.createElement('p');
      error.className = 'dropi-buy-now-error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      button.insertAdjacentElement('afterend', error);
    }

    return error;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.dropi-buy-now');
    if (!button) return;

    const systemElement = getSystemElement();
    if (!systemElement || !button.closest('[data-dropi-landing]')) return;

    event.preventDefault();
    if (requestInProgress) return;

    const variantId = getVariantId(systemElement);
    const error = getErrorElement(button);
    document.querySelectorAll('.dropi-buy-now-error').forEach((message) => {
      message.hidden = true;
      message.textContent = '';
    });

    if (!variantId) {
      if (error) {
        error.textContent = errorMessage;
        error.hidden = false;
      }
      return;
    }

    requestInProgress = true;
    const originalContent = button.innerHTML;
    button.textContent = 'PROCESANDO...';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(`${root}checkout`);
    } catch (_error) {
      button.innerHTML = originalContent;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      requestInProgress = false;

      if (error) {
        error.textContent = errorMessage;
        error.hidden = false;
      }
    }
  });
})();
